import { Injectable, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class Toaster {
  private toaster = inject(ToastrService);

  successAlert(message: string) {
    this.toaster.success(message, '', {
      timeOut: 3000,
      toastClass: `pmd-toastr toast-success ngx-toastr`
    });
  }

  errorAlert(message: string) {
    this.toaster.error(message, '', {
      timeOut: 3000,
      toastClass: `pmd-toastr toast-error ngx-toastr`
    });
  }
}
